export enum Columns {
  Actions = 'actions',
  Name = 'name',
  Email = 'email',
  Roles = 'roles',
  Customers = 'customers',
}
